import React, { useState } from 'react';
import { LuLayoutGrid } from 'react-icons/lu';
import { CiTextAlignJustify } from 'react-icons/ci';
import { GrPowerReset } from 'react-icons/gr';
import { ImFilter } from 'react-icons/im';

const Header = ({ onStatusChange, onIsVerifiedChange, onResetFilter }) => {
  const [isFilterOpen, setIsFilterOpen] = useState(false);

  const handleStatusChange = status => {
    onStatusChange(status);
  };

  const handleIsVerifiedChange = isVerified => {
    onIsVerifiedChange(isVerified);
  };

  const handleResetFilter = () => {
    onResetFilter();
    setIsFilterOpen(false);
  };

  return (
    <div className="flex justify-between items-center h-[64px] my-8 font-nohemi">
      <div className="flex justify-around rounded-lg bg-[#FFFFFF] w-[100px] h-[42px]">
        <div className="p-2">
          <CiTextAlignJustify />
        </div>
        <div className="bg-[#F1F1F1] p-2">
          <LuLayoutGrid />
        </div>
      </div>
      <div className="relative inline-flex justify-evenly items-center w-[450px] bg-[#eeeded] border rounded-lg h-[42px]">
        <div className="flex justify-center items-center text-[#000000] border-r border-gray-300 pr-2.5">
          <ImFilter
            data-testid="filter-icon"
            className="w-4 h-4 fill-gray-900"
            onClick={() => setIsFilterOpen(!isFilterOpen)}
          />
        </div>
        <div className="flex items-center h-full px-2 border-r border-gray-300">
          <p className="text-sm font-semibold text-[#202224]">Filter by</p>
        </div>
        <div className="flex items-center h-full px-2 border-r border-gray-300">
          <select
            data-testid="status-select"
            className="w-full bg-transparent text-sm font-semibold text-[#ADAEB0] focus:0 focus:outline-none"
            onChange={e => handleStatusChange(e.target.value)}>
            <option value="" disabled>
              User Status
            </option>
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>
        <div className="flex items-center h-full px-2 border-r border-gray-300">
          <select
            data-testid="verification-select"
            className="w-full bg-transparent text-sm font-semibold text-[#ADAEB0] focus:0 focus:outline-none"
            onChange={e => handleIsVerifiedChange(e.target.value)}>
            <option value="" disabled>
              Verification Status
            </option>
            <option value="true">Verified</option>
            <option value="false">Not Verified</option>
          </select>
        </div>
        <button className="flex items-center h-full cursor-pointer" onClick={handleResetFilter}>
          <p className="text-sm font-semibold inline-flex text-[#EA0234]">
            <span className="mx-1 my-auto">
              <GrPowerReset size={12} />
            </span>
            Reset
          </p>
        </button>
      </div>
    </div>
  );
};

export default Header;
